import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../lib/site";
import { Reveal } from "../../lib/motion";

const scrollToBook = () => {
  const el = document.getElementById("book");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Services = () => {
  return (
    <section id="services" className="py-24 md:py-32 bg-[#f3ebe1]" data-testid="services-section">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <Reveal>
            <p className="font-body text-xs uppercase tracking-[0.3em] text-[#c96c31] mb-5">
              Our Signature Services
            </p>
            <h2 className="font-display font-light leading-[0.95] tracking-tight text-[#2c1e16] text-4xl sm:text-5xl lg:text-6xl max-w-2xl">
              Styles crafted to your crown
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-body text-[#2c1e16]/60 max-w-xs md:text-right">
              From protective box braids to romantic boho curls — every look is tailored, never templated.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <motion.button
                data-testid={`service-card-${i}`}
                onClick={scrollToBook}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="group block w-full text-left rounded-3xl border border-[#2c1e16]/10 bg-[#f9f6f0] overflow-hidden"
              >
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <span className="absolute top-4 left-4 font-body text-xs uppercase tracking-[0.2em] bg-[#f9f6f0]/85 backdrop-blur text-[#2c1e16] px-3 py-1.5 rounded-full">
                    {s.n}
                  </span>
                </div>
                <div className="p-7">
                  <div className="flex items-center justify-between">
                    <h3 className="font-display text-2xl md:text-3xl text-[#2c1e16]">{s.title}</h3>
                    <ArrowUpRight
                      size={22}
                      className="text-[#c96c31] opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300"
                    />
                  </div>
                  <p className="mt-3 font-body text-sm md:text-base text-[#2c1e16]/65 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              </motion.button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
